<template>
    <div class="circle" ref="liquidfill"></div>
</template>

<script>
import echarts from 'echarts';
import liquidfill from 'echarts-liquidfill';

export default {
    name: 'de-liquid',
    props: {
        data: {
            type: Number,
            default: 0
        },
        fontObj: {
            type: Object,
        },
        radius: {
            type: Number
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    watch: {
        data() {
            let chart = this.getChart().chart;
            chart.setOption({
                series: [{
                    data: [this.data/100, this.data/100, this.data/100, this.data/100]
                }]
            });
        },
        radius: {
            handler() {
                this.$nextTick(function() {
                    let chart = this.getChart().chart;
                    chart && (chart.setOption({
                        series: [{
                            radius: `${this.radius}%`
                        }]
                    }));
                });
            },
            immediate: true,
            deep: true
        },
        fontObj: {
            handler() {
                this.$nextTick(function() {
                    let chart = this.getChart().chart;
                    chart && (chart.setOption({
                        series: [{
                            label: this.fontObj
                        }]
                    }));
                });
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    methods: {
        initChart(){
            let chartIns = this.getChart();
            const option = {
                series: [{
                    color: ['#003EC7', '#005DD5', '#0089FF', '#00C6FF'],
                    type: 'liquidFill',
                    data: [this.data/100, this.data/100, this.data/100, this.data/100],
                    backgroundStyle: {
                        color: '#0a0a32',
                        borderWidth: 4,
                        borderColor: '#038CFB'
                    },
                    outline: {
                        itemStyle: {
                            borderColor: '#06438A',
                            borderWidth: 2,
                            shadowBlur: 24,
                            shadowColor: '#038CFB'
                        }
                    },
                    radius: '96%',
                    label: {
                        color: '#fff',
                        fontSize: 24
                    }
                }]
            };
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs.liquidfill);
                chartIns.chart.setOption(option);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.circle {
    height: 100%;
}
</style>